import { useState, useEffect } from 'react'

export default function useWindowSize() {
	const [windowSize, setWindowSize] = useState({
		width: undefined,
		height: undefined,
	})
	useEffect(() => {
		function handleResize() {
      const newWidth = window.innerWidth;
      const newHeight = window.innerHeight;

      if (newWidth !== windowSize.width || newHeight !== windowSize.height) {
        setWindowSize({ width: newWidth, height: newHeight });
      }

		}
		window.addEventListener("resize", handleResize)
		handleResize()
		return () => window.removeEventListener("resize", handleResize)
	}, [windowSize.height, windowSize.width])

	return windowSize
}
